<section class="mx-3">
<div>
    <div class="d-flex align-items-center">
        <div>
          <button mat-icon-button class="back_icon me-2" (click)="NavigateToBack()">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
        </div>
        <!-- <div>
          <button (click)="editdata({id:35745})">edit</button>
        </div> -->
        <div>
          <h2 translate class="m-0">Role Management</h2>
        </div>
      </div>
      <div class="my-3 editrole_card bg-white card p-3 border-0">
      <div *ngFor="let userrole_type of userrole_type_list; let isFirst = first"
      [ngClass]="{'pt-3': !isFirst, 'mt-2': isFirst}">
        <div appearance="outlined" class="card p-3 light_blue_color">
           <div class="mt-2 d-flex justify-content-between">
            <div><p class="fs-16">{{userrole_type.user_role_type}}</p></div>
            <div><p>
                <mat-slide-toggle [checked]="userrole_type.is_enabled" (change)="onToggleChange($event,userrole_type.user_role_type_id)"></mat-slide-toggle>
              </p>
            </div>
           </div>
            <div class="mt-2">
                <p class="m-0 fs-12 d-flex justify-align-center"><span> <mat-icon class="fs-20">info</mat-icon></span>
                   <span translate> Click here to see what this role can do </span><mat-icon class="fs-20 ms-3">expand_more</mat-icon>
                </p>
            </div>
        </div>
      </div>
    </div>
</div>
</section>